import {
  SET_LIST_TESTIMONIAL_DATA,
  SET_LIST_TESTIMONIAL_DATA_TOTAL,
} from "../constant/actionTypes";

const initial_state = {
  listTestimonialData: null,
  listTestimonialDataTotal: 0,
};

export default (state = initial_state, action) => {
  switch (action.type) {
    case SET_LIST_TESTIMONIAL_DATA:
      return {
        ...state,
        loading: false,
        listTestimonialData: action.listTestimonialData,
      };

    case SET_LIST_TESTIMONIAL_DATA_TOTAL:
      return {
        ...state,
        loading: false,
        listTestimonialDataTotal: action.listTestimonialDataTotal,
      };

    default:
      return { ...state };
  }
};
